import styled from 'styled-components'

export const PageTemplateContainer = styled.div`
  background-color: var(--gray-0);

  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
  height: 100%;
  padding: 16px;
  gap: 32px;
  main {
    flex-grow: 1;
    flex-shrink: 0;

    .logo {
      height: 48px;
      margin-bottom: 64px;
      text-align: center;
    }

    .content {
      margin-bottom: 24px;
    }
  }

  main:not(.wide-content) {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      max-width: 356px;
    }
  }

  main.wide-content {
    display: flex;
    padding-top: 80px;
    justify-content: center;
    .content {
      width: 545px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      @media (max-width: 768px) {
        width: calc(100vw - 24px);
      }
    }
    @media (max-width: 768px) {
      padding-top: 20px;
    }
  }

  aside.side-content {
    flex-shrink: 0;
    flex-basis: 41.66%;
    min-width: 560px;
    width: 100%;
    height: 100%;
  }

  .side-image {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
`
